// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"52e441b4","948":"5f499135"}[chunkId] + ".chunk.js";
};